import { createStyles } from "antd-style";

export const useModalRequestCancelStyles = createStyles(({ css }: any) => ({
  modal: css`
    position: relative;
  `,
}));
